import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Box,
} from '@material-ui/core';

import addForAdmin from '../../../../../images/addForAdmin.svg'

import SuperAdminContext from "../../../../../contexts/SuperAdminContext"

const QuestionnaireV2Helper = ({ format }) => {

  const superAdminContext = useContext(SuperAdminContext)
  
  const handleResponseChange = (key, value, i) => {
    var data = format?.responses
    data[i][key] = value

    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const removeResponse = (i) => {
    var data = format?.responses
    data.splice(i, 1)
    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const addResponse = (e) => {
    var data = format?.responses
    data.push({ label: `${format?.responses?.length + 1}`, points: format?.responses?.length})
    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const moveCat = (i, nMove) => {
    var data = format?.responses
    const tmp = data.splice(i, 1)
    data.splice(i + nMove, 0, tmp[0])
    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  return (
    <>
      <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Catégorie</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
        <Box sx={{flex:1}}>
          <input
            value={format?.categorie || 'master'}
            style={{width:"100%"}}
            onChange={(e) => {
              superAdminContext?.onSequenceChange(
                'categorie',
                e.target.value,
                superAdminContext?.adminPlayerIndexes
              )
            }}
          />
        </Box>
      </Box>
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Paliers</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px", display:"flex", flexDirection:"column"}}>
        <Box sx={{display:"flex", alignItems:"center", justifyContent:"space-between", borderBottom:"1px solid #BABABA"}}>
          <Box sx={{display:"flex"}}>
            <p style={{marginBottom:'5px', fontSize:'10px', width:"45px"}}>Pts</p>
            <p style={{marginBottom:'5px', fontSize:'10px'}}>Texte</p>
          </Box>
        </Box>
        {format?.responses?.map((item, i)=>(
          <Box
            sx={{
              display:"flex",
              alignItems:"center",
              justifyContent:"space-between",
              borderBottom:"1px solid #BABABA",
              "&:hover" : {
                ".svgDelete" : {
                  opacity: "1 !important"
                }
              }
            }}
            id={'answer' + i}
            key={'response-' + i}
          >
            <Box sx={{
              paddingTop:"2px",
              paddingBottom:"2px"
            }}>
              <input
                value={item.points ?? 0}
                style={{width:"40px", fontSize:"12px"}}
                type="number"
                onChange={(e) => {
                  handleResponseChange('points', e.target.value ?  parseInt(e.target.value) : 0, i)
                }}
              />
              <input
                value={item.label}
                style={{marginLeft:"5px", width:"170px", fontSize:"12px"}}
                onChange={(e) => {
                  handleResponseChange('label', e.target.value, i)
                }}
              />
            </Box>
            <Box sx={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
              <svg className="svgDelete" style={{fill:"silver", opacity:0, cursor:"pointer"}} onClick={()=> { removeResponse(i) }} width="20" height="20" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" >
                <path d="m491.51 177.63h-283.02c-4.8047-0.03125-9.3945 1.9961-12.605 5.5742-3.2148 3.5742-4.7383 8.3555-4.1953 13.129l28 244.5c2.0234 17.77 10.516 34.176 23.859 46.086 13.348 11.906 30.609 18.488 48.492 18.48h120.57c18.113 0 35.574-6.7539 48.973-18.945 13.402-12.188 21.777-28.934 23.488-46.965l23.188-243.49c0.44141-4.7188-1.1328-9.4062-4.332-12.906s-7.7305-5.4844-12.469-5.4609z"/>
                <path d="m424.48 93.801c0-10.398-4.1289-20.367-11.48-27.719-7.3516-7.3516-17.324-11.48-27.719-11.48h-70.562c-10.395 0-20.367 4.1289-27.719 11.48-7.3516 7.3516-11.48 17.32-11.48 27.719v14.785h-124.77v33.602l398.49-0.003906v-33.602l-124.77 0.003907zm-33.602 14.785h-81.758v-14.785c0-3.0938 2.5078-5.6016 5.5977-5.6016h70.562c1.4844 0 2.9102 0.58984 3.957 1.6406 1.0508 1.0508 1.6406 2.4766 1.6406 3.9609z"/>
              </svg>
              {i !== 0 &&
                <Box onClick={()=> { moveCat(i,-1) }} sx={{color:"#7C7C7C", opacity:"0.3", fontSize:"12px", cursor:"pointer", marginLeft:"1px"}}>▲</Box>
              }
              {(format?.responses?.length > 1 && i !== format?.responses?.length - 1) &&
                <Box onClick={()=> { moveCat(i,+1) }} sx={{color:"#7C7C7C", opacity:"0.3", fontSize:"12px", cursor:"pointer", marginLeft:"2px"}}>▼</Box>
              }
            </Box>
          </Box>
        ))}
        <Box sx={{marginTop:"4px"}} onClick={() => { addResponse() }}>
          <Box style={{display:'flex', alignItems:'center', cursor:'pointer'}}>
            <img src={addForAdmin} style={{width:"12px"}} />
            <span style={{fontSize:"12px", marginLeft:'5px'}}>Ajoutez un palier</span>
          </Box>
        </Box>
      </Box>
    </>
  )
};

export default QuestionnaireV2Helper;
